import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry, tap } from 'rxjs/operators';
import { NotificationService } from 'src/app/services/notification.service';

/**
 * Http Interceptor for add all
 */
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const DEFAULT_HEADER_CONFIG: { [key: string]: string } = {
      'Accept': '*/*',
      'Accept-Language': 'en-US,en;q=0.9',
      'Pragma': 'no-cache',
      'Timeout': '20000',
      'Expires': '0',
      'WithCredentials': 'true',
    };

    let { headers } = req;
    Object.keys(DEFAULT_HEADER_CONFIG).forEach((key) => {
      if (!req.headers.has(key)) {
        headers = headers.set(key, DEFAULT_HEADER_CONFIG[key]);
      }
    });
    if (headers.get('formdata') === 'true') {
      const newRequest = req.clone({ headers });

      return next.handle(newRequest).pipe(
        retry(0),
        tap({
          error: (error) => this.handleError(error),
        }),
      );
    } else {
      if (headers.get('Content-Type') === undefined) {
        headers = headers.set('Content-Type', 'application/json');
      }
      const newRequest = req.clone({ headers });

      return next.handle(newRequest).pipe(
        retry(0),
        tap({
          error: (error) => this.handleError(error),
        }),
      );
    }
  }

  handleError(error: any): void {
    this.notificationService.translateAndShowError(error);
  }
}

export const AUTH_INTERCEPTOR = [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }];
